import { render } from "./TrackMetadataPanel.vue?vue&type=template&id=292e3bc2&scoped=true"
import script from "./TrackMetadataPanel.vue?vue&type=script&lang=js"
export * from "./TrackMetadataPanel.vue?vue&type=script&lang=js"

import "./TrackMetadataPanel.vue?vue&type=style&index=0&id=292e3bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292e3bc2"]])

export default __exports__